import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import LinkButton from "./LinkButton";

const DAY_MS = 24 * 60 * 60 * 1000;

const QuietBanner = ({ status }) => {
  const { t } = useTranslation("coaching-portal");
  const days = Math.max(
    2,
    Math.floor((Date.now() - new Date(status.lastEventAt).getTime()) / DAY_MS)
  );
  return (
    <div className="door-notice" data-tone="warning" role="alert">
      <SvgIcon
        src="/img/new-icons/warning-white.svg"
        useCurrentColor
        classNames="w-6 h-6 shrink-0"
      />
      <div className="door-grow">
        <span className="door-notice__overline">
          {t("doorAccess.quietBanner.title")}
        </span>
        <p>{t("doorAccess.quietBanner.text", { count: days })}</p>
      </div>
      <LinkButton
        small
        type="secondary"
        href="/coaching-portal/support/contact"
      >
        {t("doorAccess.quietBanner.contact")}
      </LinkButton>
    </div>
  );
};

export default QuietBanner;
